module.exports = __webpack_public_path__ + "img/ethnic-employee-pressing-button.d688902b.jpg";